@if (gridOptions) {
  <dv-grid
    [actions]="actions()"
    (filtersCleared)="filtersCleared()"
    class="vehicles-grid">
    <dv-quick-filter
      [agGrid]="agGrid"
      [filters]="quickFilters"
      (filterChange)="onQuickFilterChange($event)">
    </dv-quick-filter>
    <ag-grid-angular
      #agGrid
      vtGridWithSidesheet
      dvPinSelectedRow
      class="ag-theme-devinco"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (rowDataUpdated)="rowDataUpdated($event)">
    </ag-grid-angular>
  </dv-grid>

  <ng-template #menuPanelTemplate>
    <app-timed-marker-map-menu-panel
      [mapSetting]="mapSetting"
      [customForm]="customSettingsForm"
      [hideGroupMarkers]="true"
      [customFormElements]="customSettingsElements"
      (autoRefreshClicked)="onAutoRefreshClicked($event)"
      (autoZoomFitClicked)="onAutoZoomFitClicked($event)"
      (customFormChanged)="
        onCustomSettingsChanged($event)
      "></app-timed-marker-map-menu-panel>
  </ng-template>
}
